import { useContext } from 'react';
import { AppConfigContext } from 'src/config/appConfig';

export const useSelectedZone = () => useContext(AppConfigContext).zone;
